import { FC } from "react";
import styles from "./FooterPage.module.scss";
import { text1, text2, text3, text4, text5, text6, text7 } from "./constants";
import plus from "../../images/icons/plus_rose.svg";

export const DataSecurity: FC = () => {
  return (
    <div className={styles.infomation}>
      <div className={styles.infomation_conteiner}>
        <h2 className={styles.infomation__subtitle}>DSGVO</h2>
        <h1 className={styles.infomation__title}>Datenschutz</h1>
      </div>
      <p className={styles.infomation_text}>
        Die Verarbeitung Ihrer personenbezogener Daten erfolgt stets in
        Übereinstimmung mit der Datenschutz-Grundverordnung und den für den
        Anbieter geltenden landesspezifischen Datenschutzbestimmungen.
      </p>

      <p className={styles.infomation_text}>
        Unsere Website kann grundsätzlich ohne Angabe personenbezogener Daten
        genutzt werden. Sofern Sie bestimmte Leistungen über unsere Website in
        Anspruch nehmen wollen, kann eine Verarbeitung Ihrer personenbezogenen
        Daten erforderlich werden.
      </p>
      <p className={styles.infomation_text}>
        Wir haben nach Maßgabe des Art. 32 DSGVO geeignete technische und
        organisatorische Maßnahmen getroffen, um ein angemessenes Schutzniveau
        zu gewährleisten. Weiterhin haben wir Verfahren eingerichtet, die eine
        Wahrnehmung Ihrer Rechte, die Löschung von Daten und die Reaktion auf
        eine Gefährdung der Daten gewährleisten. Den Schutz Ihrer
        personenbezogenen Daten haben wir bereits bei der Entwicklung und
        Auswahl der verwendeten Hardware und Software berücksichtigt. Hiermit
        kommen wir dem Prinzip des Datenschutzes durch Technikgestaltung/durch
        datenschutzfreundliche Voreinstellungen gemäß Art. 25 DSGVO nach. Zu
        unseren Sicherheitsmaßnahmen gehören insbesondere die verschlüsselte
        Übertragung (SSL-Verschlüsselung) von Daten zwischen Ihrem Browser und
        unserem Server.
      </p>
      <h3 className={styles.infomation_header}>Definitionen</h3>
      <p className={styles.infomation_text}>
        Zur besseren Verständlichkeit unserer Datenschutzerklärung möchten wir
        Ihnen zunächst einige der verwendeten Begriffe erläutern. Im Sinne
        dieser Datenschutzerklärung bezeichnet der Ausdruck:
      </p>
      {text1.map((item, index) => (
        <div className={styles.infomation_list} key={index}>
          <img src={plus} alt="Icon not" className={styles.infomation_icon} />
          <p className={styles.infomation_text}>{item}</p>
        </div>
      ))}
      <h3 className={styles.infomation_header}>Verantwortliche</h3>
      <p className={styles.infomation_text}>
        Verantwortliche im Sinne der Datenschutz-Grundverordnung sowie der in
        den Mitgliedstaaten der Europäischen Union geltenden Datenschutzgesetze
        und anderer datenschutzrechtlicher Bestimmungen ist:
      </p>
      <h3 className={styles.infomation_header}>Cookies</h3>
      <p className={styles.infomation_text}>
        Unsere Website verwendet Cookies. Cookies sind kleine Textdateien, die
        über einen Internetbrowser auf einem Computersystem abgelegt und
        gespeichert werden.
      </p>
      <p className={styles.infomation_text}>
        Zahlreiche Websites und Server verwenden Cookies. Viele Cookies
        enthalten eine sogenannte Cookie-ID. Eine Cookie-ID ist eine eindeutige
        Kennung des Cookies. Sie besteht aus einer Zeichenfolge, durch die
        Websites und Server dem konkreten Internetbrowser zugeordnet werden
        können, in dem das Cookie gespeichert wurde. Dies ermöglicht es den
        besuchten Websites und Servern, den individuellen Browser der
        betroffenen Person von anderen Internetbrowsern, die andere Cookies
        enthalten, zu unterscheiden. Ein bestimmter Internetbrowser kann über
        die eindeutige Cookie-ID wiedererkannt und identifiziert werden.
      </p>
      <p className={styles.infomation_text}>
        Durch den Einsatz von Cookies können wir Ihnen nutzerfreundlichere
        Services bereitstellen, die ohne die Cookie-Setzung nicht möglich wären.
      </p>
      <p className={styles.infomation_text}>
        Mittels eines Cookies können die Informationen und Angebote auf unserer
        Website im Sinne des Benutzers optimiert werden. Cookies ermöglichen
        uns, wie bereits erwähnt, die Benutzer unserer Website wiederzukennen.
        Zweck dieser Wiedererkennung ist es, Ihnen die Verwendung unserer
        Websites zu erleichtern. Der Benutzer einer Website, die Cookies
        verwendet, muss beispielsweise nicht bei jedem Besuch der Internetseite
        erneut seine Zugangsdaten eingeben, weil dies von der Internetseite und
        dem auf dem Computersystem des Benutzers abgelegten Cookie übernommen
        wird. Weiterhin können wir auf unserer Website Cookies nutzen, die Ihr
        Surfverhalten während Ihres Besuches unserer Website analysieren und
        auswerten.
      </p>
      <p className={styles.infomation_text}>
        Sie werden bei Ihrem Besuch unserer Website über den Einsatz von Cookies
        mittels eines Infobanners informiert. Weiterhin werden Sie hier um Ihre
        Einwilligung gebeten und auf diese Datenschutzerklärung hingewiesen.
      </p>
      <p className={styles.infomation_text}>
        Sie können die Setzung von Cookies durch unsere Website jederzeit
        mittels einer entsprechenden Einstellung des genutzten Internetbrowsers
        verhindern und damit der Setzung von Cookies dauerhaft widersprechen.
        Ferner können bereits gesetzte Cookies jederzeit über einen
        Internetbrowser oder andere Softwareprogramme gelöscht werden. Dies ist
        in allen gängigen Internetbrowsern möglich. Sollten Sie die Setzung von
        Cookies in dem von Ihnen genutzten Internetbrowser deaktiveren, sind
        unter Umständen nicht alle Funktionen unserer Website vollumfänglich
        nutzbar. Die Löschung bzw. Änderung der Cookie-Einstellungen können Sie
        z.B. hier vornehmen:
      </p>
      {text2.map((item, index) => (
        <div className={styles.infomation_list} key={index}>
          <img src={plus} alt="Icon not" className={styles.infomation_icon} />
          <p className={styles.infomation_text}>{item}</p>
        </div>
      ))}
      <p className={styles.infomation_text}>
        Die Übertragung von Flash-Cookies können Sie über die Einstellungen
        Ihres Browsers nicht verhindern. Nutzen Sie hierzu die Einstellungen des
        Flash Players.
      </p>
      <h3 className={styles.infomation_header}>
        Daten und Informationen, die beim Aufruf unserer Website gespeichert
        werden
      </h3>
      <p className={styles.infomation_text}>
        Bei jedem Aufruf unserer Website werden allgemeine Daten und
        Informationen erfasst, die in den Logfiles des Servers gespeichert
        werden.
      </p>
      <p className={styles.infomation_text}>
        Folgende Daten/Informationen können erfasst werden:
      </p>
      {text3.map((item, index) => (
        <div className={styles.infomation_list} key={index}>
          <img src={plus} alt="Icon not" className={styles.infomation_icon} />
          <p className={styles.infomation_text}>{item}</p>
        </div>
      ))}
      <p className={styles.infomation_text}>
        Wir benötigen diese Informationen, um die Inhalte unserer Website
        zutreffend bereitstellen zu können, die dauerhafte Funktionsfähigkeit
        unseres IT-Systems gewährleisten zu können und um im Falle eines
        Cyberangriffes den Behörden die zu einer Strafverfolgung notwendigen
        Informationen bereitstellen zu können. Bei der Nutzung dieser
        allgemeinen Daten und Informationen ziehen wir keine Rückschlüsse auf
        die betroffene Person. Die anonymen Daten der Server-Logfiles speichern
        wir getrennt von allen personenbezogenen Daten.
      </p>
      <h3 className={styles.infomation_header}>
        Elektronische Kontaktaufnahme mit uns
      </h3>
      <p className={styles.infomation_text}>
        Aufgrund der Regelungen des Telemediengesetzes (TMG) sind wir zur Angabe
        einer Mailadresse und einer Telefonnummer im Impressum unserer Website
        verpflichtet, über die Sie uns kontaktieren können. Weiterhin haben Sie
        die Möglichkeit, über Kontaktformulare auf unserer Website Kontakt mit
        uns aufzunehmen. Die von Ihnen telefonisch, per Mail oder unser
        Kontaktformular an uns übermittelten personenbezogenen Daten werden
        automatisch für Zwecke der Bearbeitung oder der Kontaktaufnahme zu Ihnen
        gespeichert. Es erfolgt keine Weitergabe dieser personenbezogenen Daten
        an Dritte.
      </p>
      <p className={styles.infomation_text}>
        Rechtsgrundlage für die Verarbeitung Ihrer personenbezogenen Daten zur
        Durchführung oder Erfüllung eines Vertrages oder vorvertraglicher
        Pflichten ist Art. 6 I lit. b DSGVO. Dient Ihre Kontaktaufnahme nicht
        dem Abschluss eines Vertrages, so ist nach Abgabe Ihrer Einwilligung die
        Rechtsgrundlage für die Verarbeitung der personenbezogenen Daten der
        Art. 6 I lit. a DSGVO.
      </p>
      <p className={styles.infomation_text}>
        Ihre Angaben von personenbezogenen Daten aus der Eingabemaske unseres
        Kontaktformulars oder aus Ihrer E-Mail werden gelöscht, sobald Ihre
        Kommunikation mit uns beendet ist. Dies ist der Fall, wenn wir lebensnah
        davon ausgehen können, dass der Zweck Ihrer Kontaktaufnahme erreicht
        wurde. Alle weiteren zusätzlichen Daten löschen wir spätestens nach
        sieben Tagen.
      </p>
      <p className={styles.infomation_text}>
        Sollte Ihre Kontaktaufnahme dem Abschluss eines Vertrages dienen, werden
        Ihre Angaben zu personenbezogenen Daten bei der Kontaktaufnahme
        gelöscht, sobald Ihre Daten zur Bearbeitung und Durchführung des
        Vertrages oder unserer vorvertraglichen Pflichten nicht mehr benötigt
        werden. Sofern mit Ihnen ein Dauerschuldverhältnis besteht, löschen wir
        Ihre Daten erst nach Ende der Vertragslaufzeit. Dies gilt nicht, wenn
        wir die Daten auf Grund vertraglicher oder gesetzlicher Pflichten
        weiterhin speichern müssen. Ihre Einwilligung in die Datenverarbeitung
        können Sie jederzeit widerrufen. Sie können die erfassten Daten
        jederzeit löschen oder die gespeicherten personenbezogenen Daten ändern
        bzw. berichtigen lassen.
      </p>
      <h3 className={styles.infomation_header}>Kommentare und Beiträge</h3>
      <p className={styles.infomation_text}>
        Wenn Sie auf unserer Website Kommentare oder sonstige Beiträge
        hinterlassen, etwa im Gästebuch, wird Ihre IP-Adressen auf Grundlage
        unserer berechtigten Interessen im Sinne des Art. 6 Abs. 1 lit. f. DSGVO
        für 7 Tage gespeichert. Dies erfolgt zu unserer Sicherheit. Falls in
        Kommentaren und Beiträgen rechtswidrige Inhalte auf unserer Website zu
        finden sein sollten, können wir als Betreiber der Website für den
        Kommentar/Beitrag belangt werden. Aus diesem Grund sind wir an der
        Identität des Verfassers interessiert.
      </p>
      <h3 className={styles.infomation_header}>
        Registrierung auf unserer Website
      </h3>
      <p className={styles.infomation_text}>
        Sie können sich auf unserer Website registrieren, um zusätzliche
        Funktionen unsere Website zu nutzen. Die dazu eingegebenen Daten
        verwenden wir nur zum Zwecke der Nutzung des jeweiligen Angebotes oder
        Dienstes, für das bzw. den Sie sich registriert haben, also zur
        Erfüllung des Vertrags. Die bei der Registrierung abgefragten
        Pflichtangaben müssen vollständig angegeben werden. Anderenfalls werden
        wir die Registrierung ablehnen. Für wichtige Änderungen etwa beim
        Angebotsumfang oder bei technisch notwendigen Änderungen nutzen wir die
        bei der Registrierung angegebene E-Mail-Adresse, um Sie auf diesem Wege
        zu informieren. Die Verarbeitung Ihrer Daten beruht auf Art. 6 I lit. b
        DSGVO. Die bei der Registrierung erfassten Daten werden von uns
        gespeichert, solange Sie auf unserer Website registriert sind und werden
        anschließend gelöscht. Gesetzliche Aufbewahrungsfristen bleiben
        unberührt.
      </p>
      <h3 className={styles.infomation_header}>
        Rechtsgrundlage der Verarbeitung
      </h3>

      <p className={styles.infomation_text}>
        Sofern wir bei Ihnen eine Einwilligung für einen bestimmten
        Verarbeitungszweck einholen, dient uns Art. 6 I lit. a DSGVO als
        Rechtsgrundlage für den Verarbeitungsvorgang.
      </p>
      <p className={styles.infomation_text}>
        Sofern die Verarbeitung personenbezogener Daten zur Erfüllung eines
        Vertrags erforderlich ist, beruht die Verarbeitung auf Art. 6 I lit. b
        DSGVO. Dies gilt ebenfalls für Verarbeitungsvorgänge, die zur
        Durchführung vorvertraglicher Maßnahmen erforderlich sind, etwa bei
        Anfragen zur unseren Produkten oder sonstigen Leistungen.
      </p>
      <p className={styles.infomation_text}>
        Sofern wir einer rechtlichen Verpflichtung unterliegen, durch die eine
        Verarbeitung von personenbezogenen Daten erforderlich wird, wie
        beispielsweise zur Erfüllung steuerlicher Pflichten, so ist
        Rechtsgrundlage für die Verarbeitung Art. 6 I lit. c DSGVO.
      </p>
      <p className={styles.infomation_text}>
        Sofern die Verarbeitung von personenbezogenen Daten erforderlich wird,
        um lebenswichtige Interessen der betroffenen Person oder einer anderen
        natürlichen Person zu schützen, würde die Verarbeitung auf Art. 6 I lit.
        d DSGVO beruhen.
      </p>
      <p className={styles.infomation_text}>
        Letztlich kann Art. 6 I lit. f DSGVO Rechtsgrundlage für einen
        Verarbeitungsvorgang sein. Dies ist dann der Fall, wenn der
        Verarbeitungsvorgang von keiner der vorgenannten Rechtsgrundlagen
        erfasst wird und die Verarbeitung zur Wahrung eines berechtigten
        Interesses unseres Unternehmens oder eines Dritten erforderlich ist,
        sofern die Interessen, Grundrechte und Grundfreiheiten des Betroffenen
        nicht überwiegen. Basiert die Verarbeitung personenbezogener Daten auf
        Artikel 6 I lit. f DSGVO ist unser berechtigtes Interesse die
        Durchführung unserer Geschäftstätigkeit zugunsten des Wohlergehens
        unserer Mitarbeiter/Anteilseigner.
      </p>
      <h3 className={styles.infomation_header}>
        Gesetzliche oder vertragliche Vorschriften zur Bereitstellung der
        personenbezogenen Daten
      </h3>
      <p className={styles.infomation_text}>
        Die Bereitstellung personenbezogener Daten ist zum Teil gesetzlich
        vorgeschrieben ist (z.B. Steuervorschriften) und kann sich auch aus
        vertraglichen Regelungen (z.B. Angaben zum Vertragspartner) ergeben. Für
        den Fall, dass Sie einen Vertrag mit uns abschließen wollen, ist es
        erforderlich, dass Sie uns personenbezogene Daten zur Verfügung stellen,
        die in der Folge durch uns verarbeitet werden. Eine Nichtbereitstellung
        der personenbezogenen Daten hätte zur Folge, dass wir keinen Vertrag mit
        Ihnen schließen können.
      </p>
      <h3 className={styles.infomation_header}>
        Routinemäßige Löschung/Sperrung von personenbezogenen Daten
      </h3>

      <p className={styles.infomation_text}>
        Wir verarbeiten und speichern personenbezogene Daten nur für den
        Zeitraum, der zur Erreichung des Speicherungszwecks erforderlich ist
        oder sofern dies durch den Europäischen Richtlinien-und Verordnungsgeber
        oder einen anderen Gesetzgeber in Gesetzen oder Vorschriften vorgesehen
        wurde. Entfällt der Speicherungszweck oder läuft eine vom Europäischen
        Richtlinien-und Verordnungsgeber oder einem anderen zuständigen
        Gesetzgeber vorgeschriebene Speicherfrist ab, werden die
        personenbezogenen Daten routinemäßig und entsprechend den gesetzlichen
        Vorschriften gesperrt oder gelöscht.
      </p>
      <p className={styles.infomation_text}>
        Nach Ablauf der jeweiligen gesetzlichen Aufbewahrungsfrist werden die
        entsprechenden Daten routinemäßig gelöscht, sofern sie nicht mehr zur
        Vertragserfüllung oder Vertragsanbahnung erforderlich sind.
      </p>
      <h3 className={styles.infomation_header}>
        Ihre Rechte Bestätigungs- und Auskunftsrecht
      </h3>
      <p className={styles.infomation_text}>
        Sie haben das Recht, von uns eine Bestätigung darüber zu verlangen, ob
        betreffende personenbezogene Daten verarbeitet werden. Möchten Sie Recht
        in Anspruch nehmen, können sie sich hierzu jederzeit an uns wenden.
      </p>
      <p className={styles.infomation_text}>
        Sie haben weiterhin das Recht, von uns unentgeltliche Auskunft über die
        zu Ihrer Person gespeicherten personenbezogenen Daten und eine Kopie
        dieser Auskunft zu erhalten. Ferner steht Ihnen ein Auskunftsanspruch
        über folgende Informationen zu:
      </p>
      {text4.map((item, index) => (
        <div className={styles.infomation_list} key={index}>
          <img src={plus} alt="Icon not" className={styles.infomation_icon} />
          <p className={styles.infomation_text}>{item}</p>
        </div>
      ))}
      <p className={styles.infomation_text}>
        Ferner steht Ihnen ein Auskunftsrecht darüber zu, ob personenbezogene
        Daten an ein Drittland oder an eine internationale Organisation
        übermittelt wurden. Sofern dies der Fall ist, so steht Ihnen im Übrigen
        das Recht zu, Auskunft über die geeigneten Garantien im Zusammenhang mit
        der Übermittlung zu erhalten.
      </p>
      <p className={styles.infomation_text}>
        Möchten Sie dieses Auskunftsrecht in Anspruch nehmen, können sie sich
        hierzu jederzeit an uns wenden.
      </p>
      <h3 className={styles.infomation_header}>Recht auf Berichtigung</h3>

      <p className={styles.infomation_text}>
        Sie haben das Recht, die unverzügliche Berichtigung sie betreffender
        unrichtiger personenbezogener Daten zu verlangen. Ferner steht Ihnen das
        Recht zu, unter Berücksichtigung der Zwecke der Verarbeitung, die
        Vervollständigung unvollständiger personenbezogener Daten -auch mittels
        einer ergänzenden Erklärung - zu verlangen. Möchten Sie dieses
        Berichtigungsrecht in Anspruch nehmen, können sie sich hierzu jederzeit
        an uns wenden.
      </p>
      <h3 className={styles.infomation_header}>
        Recht auf Löschung („Recht auf „Vergessenwerden“)
      </h3>
      <p className={styles.infomation_text}>
        Sie haben das Recht, von uns zu verlangen, dass die sie betreffenden
        personenbezogenen Daten unverzüglich gelöscht werden, sofern einer der
        folgenden Gründe zutrifft und soweit die Verarbeitung nicht erforderlich
        ist:
      </p>
      {text5.map((item, index) => (
        <div className={styles.infomation_list} key={index}>
          <img src={plus} alt="Icon not" className={styles.infomation_icon} />
          <p className={styles.infomation_text}>{item}</p>
        </div>
      ))}
      <p className={styles.infomation_text}>
        Sofern einer der oben genannten Gründe zutrifft und Sie die Löschung von
        personenbezogenen Daten, die bei uns gespeichert sind, veranlassen
        möchten, können sie sich hierzu jederzeit an uns wenden. Wir werden
        veranlassen, dass dem Löschverlangen unverzüglich nachgekommen wird.
      </p>
      <p className={styles.infomation_text}>
        Wurden die personenbezogenen Daten von uns öffentlich gemacht und sind
        wir als Verantwortlicher gemäß Art. 17 Abs. 1 DSGVO zur Löschung der
        personenbezogenen Daten verpflichtet, so treffen wir unter
        Berücksichtigung der verfügbaren Technologie und der
        Implementierungskosten angemessene Maßnahmen, auch technischer Art, um
        andere für die Datenverarbeitung Verantwortliche, welche die
        veröffentlichten personenbezogenen Daten verarbeiten, darüber in
        Kenntnis zu setzen, dass Sie von diesen anderen für die
        Datenverarbeitung Verantwortlichen die Löschung sämtlicher Links zu
        diesen personenbezogenen Daten oder von Kopien oder Replikationen dieser
        personenbezogenen Daten verlangt haben, soweit die Verarbeitung nicht
        erforderlich ist. Wir werden im Einzelfall das Notwendige veranlassen.
      </p>
      <h3 className={styles.infomation_header}>
        Recht auf Einschränkung der Verarbeitung
      </h3>

      <p className={styles.infomation_text}>
        Sie haben das Recht, von uns die Einschränkung der Verarbeitung zu
        verlangen, wenn eine der folgenden Voraussetzungen gegeben ist:
      </p>
      {text6.map((item, index) => (
        <div className={styles.infomation_list} key={index}>
          <img src={plus} alt="Icon not" className={styles.infomation_icon} />
          <p className={styles.infomation_text}>{item}</p>
        </div>
      ))}
      <p className={styles.infomation_text}>
        Sofern eine der oben genannten Voraussetzungen gegeben ist und Sie die
        Einschränkung von personenbezogenen Daten, die bei uns gespeichert sind,
        verlangen möchten, können Sie sich hierzu jederzeit an uns wenden. Wir
        werden die Einschränkung der Verarbeitung veranlassen.
      </p>
      <h3 className={styles.infomation_header}>
        Recht auf Datenübertragbarkeit
      </h3>
      <p className={styles.infomation_text}>
        Sie haben das Recht, von uns die sie betreffenden personenbezogenen
        Daten, welche von Ihnen bereitgestellt wurden, in einem strukturierten,
        gängigen und maschinenlesbaren Format zu erhalten. Sie haben außerdem
        das Recht, diese Daten einem anderen Verantwortlichen ohne Behinderung
        durch uns zu übermitteln, sofern die Verarbeitung auf der Einwilligung
        gemäß Art. 6 Abs. 1 Buchstabe a DSGVO oder Art. 9 Abs. 2 Buchstabe a
        DSGVO oder auf einem Vertrag gemäß Art. 6 Abs. 1 Buchstabe b DSGVO
        beruht und die Verarbeitung mithilfe automatisierter Verfahren erfolgt,
        sofern die Verarbeitung nicht für die Wahrnehmung einer Aufgabe
        erforderlich ist, die im öffentlichen Interesse liegt oder in Ausübung
        öffentlicher Gewalt erfolgt, welche uns übertragen wurde.
      </p>
      <p className={styles.infomation_text}>
        Ferner haben Sie bei der Ausübung ihres Rechts auf Datenübertragbarkeit
        gemäß Art. 20 Abs. 1 DSGVO das Recht, zu erwirken, dass die
        personenbezogenen Daten direkt von uns an einen anderen Verantwortlichen
        übermittelt werden, soweit dies technisch machbar ist und sofern hiervon
        nicht die Rechte und Freiheiten anderer Personen beeinträchtigt werden.
        Zur Geltendmachung des Rechts auf Datenübertragbarkeit können Sie sich
        jederzeit an uns wenden.
      </p>
      <h3 className={styles.infomation_header}>Recht auf Widerspruch</h3>

      <p className={styles.infomation_text}>
        Sie haben das Recht, aus Gründen, die sich aus ihrer besonderen
        Situation ergeben, jederzeit gegen die Verarbeitung sie betreffender
        personenbezogener Daten, die aufgrund von Art. 6 Abs. 1 Buchstaben e
        oder f DSGVO erfolgt, Widerspruch einzulegen. Dies gilt auch für ein auf
        diese Bestimmungen gestütztes Profiling.
      </p>
      <p className={styles.infomation_text}>
        Wir verarbeiten die personenbezogenen Daten im Falle des Widerspruchs
        nicht mehr, es sei denn, wir können zwingende schutzwürdige Gründe für
        die Verarbeitung nachweisen, die Ihre Interessen, Rechte und Freiheiten
        überwiegen, oder die Verarbeitung dient der Geltendmachung, Ausübung
        oder Verteidigung von Rechtsansprüchen.
      </p>
      <p className={styles.infomation_text}>
        Verarbeiten wir personenbezogene Daten, um Direktwerbung zu betreiben,
        so haben Sie das Recht, jederzeit Widerspruch gegen die Verarbeitung der
        personenbezogenen Daten zum Zwecke derartiger Werbung einzulegen. Dies
        gilt auch für das Profiling, soweit es mit solcher Direktwerbung in
        Verbindung steht. Widersprechen Sie der Verarbeitung für Zwecke der
        Direktwerbung, so werden wir die personenbezogenen Daten nicht mehr für
        diese Zwecke verarbeiten.
      </p>
      <p className={styles.infomation_text}>
        Zudem haben Sie das Recht, aus Gründen, die sich aus ihrer besonderen
        Situation ergeben, gegen die sie betreffende Verarbeitung
        personenbezogener Daten, die bei uns zu wissenschaftlichen oder
        historischen Forschungszwecken oder zu statistischen Zwecken gemäß Art.
        89 Abs. 1 DSGVO erfolgen, Widerspruch einzulegen, es sei denn, eine
        solche Verarbeitung ist zur Erfüllung einer im öffentlichen Interesse
        liegenden Aufgabe erforderlich.
      </p>
      <p className={styles.infomation_text}>
        Zur Ausübung des Rechts auf Widerspruch können Sie sich an uns wenden.
        Es steht Ihnen frei, im Zusammenhang mit der Nutzung von Diensten der
        Informationsgesellschaft, ungeachtet der Richtlinie 2002/58/EG, ihr
        Widerspruchsrecht mittels automatisierter Verfahren auszuüben, bei denen
        technische Spezifikationen verwendet werden.
      </p>
      <h3 className={styles.infomation_header}>
        Automatisierte Entscheidungen im Einzelfall einschließlich Profiling
      </h3>
      <p className={styles.infomation_text}>
        Sie haben das Recht, nicht einer ausschließlich auf einer
        automatisierten Verarbeitung -einschließlich Profiling - beruhenden
        Entscheidung unterworfen zu werden, die Ihnen gegenüber rechtliche
        Wirkung entfaltet oder sie in ähnlicher Weise erheblich beeinträchtigt,
        sofern die Entscheidung nicht für den Abschluss oder die Erfüllung eines
        Vertrags zwischen Ihnen und uns erforderlich ist, oder aufgrund von
        Rechtsvorschriften der Union oder der Mitgliedstaaten, denen wir
        unterliegen, zulässig ist und diese Rechtsvorschriften angemessene
        Maßnahmen zur Wahrung Ihrer Rechte und Freiheiten enthalten oder mit
        Ihrer ausdrücklicher Einwilligung erfolgt.
      </p>
      <p className={styles.infomation_text}>
        Ist die Entscheidung für den Abschluss oder die Erfüllung eines Vertrags
        zwischen Ihnen und uns erforderlich oder erfolgt sie mit Ihrer
        ausdrücklicher Einwilligung, treffen wir angemessene Maßnahmen, um Ihre
        Rechte und Freiheiten sowie Ihre berechtigten Interessen zu wahren, wozu
        mindestens das Recht auf Erwirkung des Eingreifens einer Person seitens
        des Verantwortlichen, auf Darlegung des eigenen Standpunkts und auf
        Anfechtung der Entscheidung gehört.
      </p>
      <p className={styles.infomation_text}>
        Möchten Sie Rechte mit Bezug auf automatisierte Entscheidungen geltend
        machen, können Sie sich hierzu jederzeit an uns wenden.
      </p>
      <h3 className={styles.infomation_header}>
        Recht auf Widerruf einer datenschutzrechtlichen Einwilligung
      </h3>
      <p className={styles.infomation_text}>
        Sie haben das Recht, eine Einwilligung zur Verarbeitung
        personenbezogener Daten jederzeit zu widerrufen. Möchten Sie Ihr Recht
        auf Widerruf einer Einwilligung geltend machen, können Sie sich hierzu
        jederzeit an uns wenden.
      </p>
      <h3 className={styles.infomation_header}>
        Beschwerderecht bei der Aufsichtsbehörde
      </h3>
      <p className={styles.infomation_text}>
        Sie haben gemäß Art. 77 DSGVO das Recht, sich bei der Aufsichtsbehörde
        zu beschweren, wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer
        personenbezogenen Daten nicht rechtmäßig erfolgt.
      </p>
      <h3 className={styles.infomation_header}>
        Zusammenarbeit mit Auftragsverarbeitern/Dritten
      </h3>
      <p className={styles.infomation_text}>
        Soweit wir im Rahmen unserer Datenverarbeitung Ihre Daten gegenüber
        anderen Personen/ Unternehmen offenbaren, an diese übermitteln oder
        diesen Zugriff auf Ihre Daten gewähren, erfolgt dies ausschließlich auf
        Grundlage einer gesetzlichen Erlaubnis, Ihrer Einwilligung, einer
        rechtlichen Verpflichtung oder auf Grundlage unserer berechtigten
        Interessen. Wenn Dritte von uns mit der Verarbeitung von Daten auf
        Grundlage eines so genannten „Auftragsverarbeitungsvertrages“ beauftragt
        worden sind bzw. werden, geschieht dies auf Grundlage des Art. 28 DSGVO.
      </p>
      <h3 className={styles.infomation_header}>
        Übermittlungen in Drittländer
      </h3>
      <p className={styles.infomation_text}>
        Sofern auf unserer Website Funktionen oder Dienste externer dritter
        Anbieter mit Sitz im nichteuropäischen Ausland zur Verfügung gestellt
        werden, können Ihre personenbezogenen Daten auch außerhalb der
        Europäischen Union oder des Europäischen Wirtschaftsraumes verarbeitet
        und gespeichert werden. Hierbei werden die gesetzliche Vorgaben
        beachtet. Ihre personenbezogenen Daten werden nur dann übermittelt, wenn
        Sie vorab darüber informiert worden sind und Sie ausdrücklich zugestimmt
        haben oder dies aus vertraglichen bzw. gesetzlichen Gründen erforderlich
        ist. Zudem müssen in dem Drittland ein anerkanntes Datenschutzniveau,
        eine vertragliche Verpflichtung durch Standartschutzklauseln der
        EU-Kommission, das Vorliegen von Zertifizierungen oder verbindliche
        interne Datenschutzvorschriften bestehen.
      </p>
      <h3 className={styles.infomation_header}>
        Profile in „Sozialen Netzwerken“
      </h3>
      <p className={styles.infomation_text}>
        Wir betreiben Profile in so genannten „Sozialen Netzwerken“ und
        ähnlichen Plattformen, um dort mit unseren Kunden und sonstigen
        Interessenten an unserem Unternehmen kommunizieren zu können. Es gelten
        diesbezüglich die Geschäftsbedingungen und Datenverarbeitungsrichtlinien
        der jeweiligen Betreiber. Sofern dieser Datenschutzerklärung keine
        anderweitigen Regelungen zu entnehmen sind, werden die Daten der Nutzer,
        die mit uns über „Soziale Netzwerke“ und ähnliche Plattformen
        kommunizieren, durch uns verarbeitet.
      </p>
      <h3 className={styles.infomation_header}>
        Google Analytics mit Anonymisierungsfunktion
      </h3>
      <p className={styles.infomation_text}>
        Wir verwenden auf unserer Website Google Analytics, einen
        Webanalysedienst der Google Inc., 1600 Amphitheatre Parkway Mountain
        View, CA 94043, USA („Google“). Google verwendet für die Webanalyse
        Cookies. Die Cookies werden zum Zweck der Analyse Ihres
        Nutzungs-verhaltens während des Besuchs unserer Website gespeichert. Es
        werden hierzu folgende Daten erhoben:
      </p>
      {text7.map((item, index) => (
        <div className={styles.infomation_list} key={index}>
          <img src={plus} alt="Icon not" className={styles.infomation_icon} />
          <p className={styles.infomation_text}>{item}</p>
        </div>
      ))}
      <p className={styles.infomation_text}>
        Diese Daten werden in der Regel an einen Server von Google in den USA
        übermittelt und in den USA gespeichert. Die USA sind kein Mitgliedstaat
        der Europäischen Union oder des europäischen Wirtschaftsraums. Für die
        USA besteht kein Angemessenheitsbeschluss der EU-Kommission.
      </p>
      <p className={styles.infomation_text}>
        Ihre IP-Adresse wird anderen Daten von Google nicht zugeordnet und in
        der Regel vor der Übermittlung in die USA anonymisiert, indem diese um
        die letzten 8-Bit verkürzt wird. Damit ist eine individuelle Zuordnung
        nicht mehr möglich. Die Kürzung Ihrer (IP)-Adresse erfolgt innerhalb der
        (EU) oder in Vertragsstaaten des EEG.
      </p>
      <p className={styles.infomation_text}>
        Ihre personenbezogenen Daten werden von Google in unserem Auftrag im
        Hinblick auf Ihr Nutzungsverhalten auf unserer Webseite analysiert.
        Weiterhin erstellt Google für uns Statistiken über Ihre Aktivitäten auf
        unserer Website. Mit Hilfe der übermittelten Daten werden anonyme
        Nutzungsprofile der Besucher unserer Website erstellt, durch die wir
        unsere Webseite optimieren, weiterentwickeln und anpassen können. Google
        selbst verfolgt den Zweck weitere Dienstleistungen im Zusammenhang mit
        der Internetnutzung anbieten und optimieren zu können.
      </p>
      <p className={styles.infomation_text}>
        Google wird die übermittelten Informationen gegebenenfalls an Dritte
        übertragen, sofern dies gesetzlich vorgeschrieben oder soweit Dritte
        diese Daten im Auftrag von Google verarbeiten.
      </p>
      <p className={styles.infomation_text}>
        Rechtsgrundlage für die Verarbeitung der personenbezogenen Daten ist
        Art. 6 I lit. a DSGVO, sofern Sie Ihre Einwilligung erteilt haben.
        Ansonsten ist die Rechtsgrundlage Art. 6 I lit. f DSGVO, also unser
        berechtigtes Interesse.
      </p>
      <p className={styles.infomation_text}>
        Sie können die Speicherung oder Installation der Cookies durch eine
        entsprechende Einstellung Ihrer Browser-Software verhindern oder
        einschränken. Bereits gespeicherte Cookies können jederzeit gelöscht
        werden. Durch die Deaktivierung der Cookies kann die Funktionalität
        unserer Website eingeschränkt sein. Sie haben zusätzlich die
        Möglichkeit, die Erhebung Ihrer (IP)-Adresse, die Verarbeitung Ihrer
        personenbezogenen Daten und die Analyse Ihres Nutzungsverhaltens durch
        Cookies auszuschließen. Dafür müssen Sie sich unter dem folgenden Link
        ein Browser-Plugin herunterladen und installieren:
        http://tools.google.com/dlpage/gaoptout?hl=de.
      </p>
      <p className={styles.infomation_text}>
        Einstellungen für die Darstellung von Werbeeinblendungen:
        https://adssettings.google.com/authenticated.
      </p>
      <p className={styles.infomation_text}>
        Weitere Informationen zur Datennutzung zu Werbezwecken durch Google,
        Einstellungs- und Widerspruchsmöglichkeiten erhalten Sie auf den
        Webseiten von Google: http://www.google.com/analytics/terms/de.html
      </p>
      <p className={styles.infomation_text}>
        Wir nutzen Google Analytics, um Daten aus Google Ads (vorher AdWords)
        für interne Statistiken zu analysieren. Sollten Sie diese Analyse nicht
        wünschen, finden Sie weitere Informationen unter Google Ads.
      </p>
      <h3 className={styles.infomation_header}>Facebook</h3>
      <p className={styles.infomation_text}>
        Wir verwenden auf Grundlage unserer berechtigten Interessen im Sinne des
        Art. 6 Abs. 1 lit. f. DSGVO Komponenten des Unternehmens Facebook.
      </p>
      <p className={styles.infomation_text}>
        Facebook ist ein Dienst der Facebook Inc., 1 Hacker Way, Menlo Park, CA
        94025, USA. Für die Verarbeitung personenbezogener Daten
        Verantwortlicher ist, wenn Sie außerhalb der USA oder Kanada leben, die
        Facebook Ireland Ltd., 4 Grand Canal Square, Grand Canal Harbour, Dublin
        2, Ireland.
      </p>
      <p className={styles.infomation_text}>
        Durch jeden Aufruf unserer Website, auf der eine Facebook-Komponente
        (Facebook-Plug-In) integriert wurde, wird Ihr Internetbrowser
        automatisch durch die jeweilige Facebook-Komponente veranlasst, eine
        Darstellung der entsprechenden Facebook-Komponente von Facebook
        herunterzuladen. Eine Gesamtübersicht über alle Facebook-Plug-Ins kann
        unter https:// developers.facebook.com/docs/plugins/?locale=de_DE
        abgerufen werden. Im Rahmen dieses technischen Verfahrens erhält
        Facebook Kenntnis darüber, welche konkrete Unterseite unserer Website
        Sie besucht haben.
      </p>
      <p className={styles.infomation_text}>
        Sofern Sie gleichzeitig bei Facebook eingeloggt sind, erkennt Facebook
        mit jedem Aufruf unserer Website durch Sie und während der gesamten
        Dauer Ihres Aufenthaltes auf unserer Website, welche konkrete Unterseite
        unserer Website Sie besuchen. Diese Informationen werden durch die
        Facebook-Komponente gesammelt und durch Facebook Ihrem jeweiligen
        Facebook-Account zugeordnet. Betätigten Sie einen der auf unserer
        Website integrierten Facebook-Buttons, beispielsweise den „Gefällt
        mir“-Button, oder geben Sie einen Kommentar ab, ordnet Facebook diese
        Information Ihrem persönlichen Facebook-Benutzerkonto zu und speichert
        diese personenbezogenen Daten.
      </p>
      <p className={styles.infomation_text}>
        Facebook erhält über die Facebook-Komponente immer dann eine Information
        darüber, dass Sie unsere Website besucht haben, wenn Sie zum Zeitpunkt
        des Aufrufs unserer Website gleichzeitig bei Facebook eingeloggt sind.
        Dies findet unabhängig davon statt, ob Sie die Facebook-Komponente
        anklicken oder nicht. Ist eine derartige Übermittlung dieser
        Informationen an Facebook Ihrerseits nicht gewollt, können Sie die
        Übermittlung dadurch verhindern, dass sie sich vor einem Aufruf unserer
        Website aus Ihrem Facebook-Account ausloggen.
      </p>
      <p className={styles.infomation_text}>
        Die von Facebook veröffentlichte Datenrichtlinie, die unter
        https://de-de.facebook.com/about/privacy/ abrufbar ist, gibt Aufschluss
        über die Erhebung, Verarbeitung und Nutzung personenbezogener Daten
        durch Facebook. Ferner wird dort erläutert, welche
        Einstellungsmöglichkeiten Facebook zum Schutz Ihrer Privatsphäre bietet.
        Zudem sind unterschiedliche Applikationen erhältlich, die es
        ermöglichen, eine Datenübermittlung an Facebook zu unterdrücken,
        beispielsweise der Facebook-Blocker des Anbieters Webgraph, der unter
        http://webgraph.com/resources/facebookblocker/ beschafft werden kann.
        Sie können solche Applikationen nutzen, um eine Datenübermittlung an
        Facebook zu unterdrücken.
      </p>
      <h3 className={styles.infomation_header}>Instagram</h3>

      <p className={styles.infomation_text}>
        Wir greifen auf die technische Plattform und die Dienste der Instagram
        Inc., 1601 Willow Road, Menlo Park, CA, 94025, USA zurück. Beim Besuch
        unserer Instagram-Seite erfasst Instagram unter anderem Ihre IP-Adresse
        sowie weitere Informationen, die in Form von Cookies auf Ihrem PC
        vorhanden sind. Diese Informationen werden verwendet, um uns als
        Betreiber der Instagram-Seiten statistische Informationen über die
        Inanspruchnahme der Instagram-Seite zur Verfügung zu stellen.
      </p>
      <p className={styles.infomation_text}>
        Die in diesem Zusammenhang über Sie erhobenen Daten werden von der
        Instagram Inc. verarbeitet und dabei gegebenenfalls in Länder außerhalb
        der Europäischen Union übertragen. Welche Informationen Instagram erhält
        und wie diese verwendet werden, beschreibt Instagram in allgemeiner Form
        in seinen Datenschutzrichtlinien. Dort finden Sie auch Informationen
        über Kontaktmöglichkeiten zu Instagram sowie zu den
        Einstellmöglichkeiten für Werbeanzeigen.
      </p>
      <p className={styles.infomation_text}>
        Die Datenschutzrichtlinien sind unter folgendem Link verfügbar:
        https://help.instagram.com/ 519522125107875
      </p>
      <p className={styles.infomation_text}>
        In welcher Weise Instagram die Daten aus dem Besuch von Instagram-Seiten
        für eigene Zwecke verwendet, in welchem Umfang Aktivitäten auf der
        Instagram-Seite einzelnen Nutzern zugeordnet werden, wie lange Instagram
        diese Daten speichert und ob Daten aus einem Besuch der Instagram-Seite
        an Dritte weitergegeben werden, wird von Instagram nicht abschließend
        und klar benannt und ist uns nicht bekannt.
      </p>
      <p className={styles.infomation_text}>
        Beim Zugriff auf eine Instagram-Seite wird die Ihrem Endgeräte
        zugeteilte IP-Adresse an Instagram übermittelt. Nach Auskunft von
        Instagram wird diese IP-Adresse anonymisiert (bei „deutschen”
        IP-Adressen) und nach 90 Tagen gelöscht. Instagram speichert darüber
        hinaus Informationen über die Endgeräte seiner Nutzer (zum Beispiel im
        Rahmen der Funktion „Anmeldebenachrichtigung“); gegebenenfalls ist
        Instagram damit eine Zuordnung von IP-Adressen zu einzelnen Nutzern
        möglich.
      </p>
      <p className={styles.infomation_text}>
        Wenn Sie aktuell bei Instagram angemeldet sind, befindet sich auf Ihrem
        Endgerät ein Cookie mit Ihrer Instagram-Kennung. Dadurch ist Instagram
        in der Lage nachzuvollziehen, dass Sie diese Seite aufgesucht und wie
        Sie sie genutzt haben. Dies gilt auch für alle anderen Instagram-Seiten.
        Über in Webseiten eingebundene Instagram-Buttons ist es Instagram
        möglich, Ihre Besuche auf diesen Webseiten Seiten zu erfassen und Ihrem
        Instagram-Profil zuzuordnen. Anhand dieser Daten können Inhalte oder
        Werbung auf Sie zugeschnitten angeboten werden.
      </p>
      <p className={styles.infomation_text}>
        Wenn Sie dies vermeiden möchten, sollten Sie sich bei Instagram abmelden
        beziehungsweise die Funktion „angemeldet bleiben” deaktivieren, die auf
        Ihrem Gerät vorhandenen Cookies löschen und Ihren Browser beenden und
        neu starten. Auf diese Weise werden Instagram-Informationen, über die
        Sie unmittelbar identifiziert werden können, gelöscht. Damit können Sie
        unsere Instagram-Seite nutzen, ohne dass Ihre Instagram-Kennung
        offenbart wird.
      </p>
      <p className={styles.infomation_text}>
        Wenn Sie auf interaktive Funktionen der Seite zugreifen (Gefällt mir,
        Kommentieren, Nachrichten und weitere), erscheint eine
        Instagram-Anmeldemaske. Nach einer etwaigen Anmeldung sind Sie für
        Instagram erneut als bestimmte/r Nutzerin/Nutzer erkennbar.
      </p>
      <p className={styles.infomation_text}>
        Informationen dazu, wie Sie über Sie vorhandene Informationen verwalten
        oder löschen können, finden Sie auf folgenden Instagram-Hilfebereich.
      </p>
      <h3 className={styles.infomation_header}>Twitter</h3>
      <p className={styles.infomation_text}>
        Wir greifen für den angebotenen Kurznachrichtendienst auf die technische
        Plattform und die Dienste der Twitter Inc., 1355 Market Street, Suite
        900, San Francisco, CA 94103 U.S.A. zurück. Verantwortlich für die
        Datenverarbeitung von außerhalb der Vereinigten Staaten lebenden
        Personen ist die Twitter International Company, One Cumberland Place,
        Fenian Street, Dublin 2 D02 AX07, Irland.
      </p>
      <p className={styles.infomation_text}>
        Angaben darüber, welche Daten durch Twitter verarbeitet und zu welchen
        Zwecken genutzt werden, finden Sie in der Datenschutzerklärung von
        Twitter: https://twitter.com/de/privacy
      </p>
      <p className={styles.infomation_text}>
        Die durch die Cookies gesammelten Informationen dieses Anbieters werden
        im Regelfall an einen Server in den USA gesandt und dort gespeichert.
        Die USA sind kein Mitgliedstaat der Europäischen Union oder des
        europäischen Wirtschaftsraums. Für die USA besteht kein
        Angemessenheitsbeschluss der EU-Kommission.
      </p>
      <p className={styles.infomation_text}>
        Wir haben keinen Einfluss auf Art und Umfang der durch Twitter
        verarbeiteten Daten, die Art der Verarbeitung und Nutzung oder die
        Weitergabe dieser Daten an Dritte. Auch haben wir insoweit keine
        effektiven Kontrollmöglichkeiten. Mit der Verwendung von Twitter werden
        Ihre personenbezogenen Daten von der Twitter Inc. erfasst, übertragen,
        gespeichert, offengelegt und verwendet und dabei unabhängig von Ihrem
        Wohnsitz in die Vereinigten Staaten, Irland und jedes andere Land, in
        dem die Twitter Inc. geschäftlich tätig wird, übertragen und dort
        gespeichert und genutzt. Twitter verarbeitet dabei zum einen Ihre
        freiwillig eingegebenen Daten wie Name und Nutzername, E-Mail-Adresse,
        Telefonnummer oder die Kontakte Ihres Adressbuches, wenn Sie dieses
        hochladen oder synchronisieren. Zum anderen wertet Twitter aber auch die
        von Ihnen geteilten Inhalte daraufhin aus, an welchen Themen Sie
        interessiert sind, speichert und verarbeitet vertrauliche Nachrichten,
        die Sie direkt an andere Nutzer schicken und kann Ihren Standort anhand
        von GPS-Daten, Informationen zu Drahtlosnetzwerken oder über Ihre
        IP-Adresse bestimmen, um Ihnen Werbung oder andere Inhalte zukommen zu
        lassen.
      </p>
      <p className={styles.infomation_text}>
        Zur Auswertung benutzt die Twitter Inc. unter Umständen Analyse-Tools
        wie Twitter- oder Google-Analytics. Wir haben keinen Einfluss auf eine
        Nutzung solcher Tools durch die Twitter Inc. und wurden über einen
        solchen potentiellen Einsatz auch nicht informiert. Sollten Tools dieser
        Art von der Twitter Inc. für unseren Account eingesetzt werden, haben
        wir dies weder in Auftrag gegeben, noch abgesegnet oder sonst in
        irgendeiner Art unterstützt. Auch werden uns die bei der Analyse
        gewonnenen Daten nicht zur Verfügung gestellt. Lediglich bestimmte,
        nicht-personenbezogene Informationen über die Tweet-Aktivität, also etwa
        die Anzahl der Profil- oder Link-Klicks durch einen bestimmten Tweet,
        sind für uns über ihren Account einsehbar. Überdies haben wir keine
        Möglichkeit, den Einsatz solcher Tools auf ihrem Twitter-Account zu
        verhindern oder abzustellen.
      </p>
      <p className={styles.infomation_text}>
        Schließlich erhält Twitter auch Informationen, wenn Sie zum Beispiel
        Inhalte ansehen, auch wenn Sie keinen Account erstellt haben. Bei diesen
        sogenannte „Log-Daten” kann es sich um die IP-Adresse, den Browsertyp,
        das Betriebssystem, Informationen zu der zuvor aufgerufenen Website und
        den von Ihnen aufgerufenen Seiten, Ihrem Standort, Ihrem
        Mobilfunkanbieter, dem von Ihnen genutzten Endgerät (einschließlich
        Geräte-ID und Anwendungs-ID), die von Ihnen verwendeten Suchbegriffe und
        Cookie-Informationen handeln.
      </p>
      <p className={styles.infomation_text}>
        Über in Webseiten eingebundene Twitter-Buttons oder -Widgets und die
        Verwendung von Cookies ist es Twitter möglich, Ihre Besuche auf diesen
        Webseiten zu erfassen und Ihrem Twitter-Profil zuzuordnen. Anhand dieser
        Daten können Inhalte oder Werbung auf Sie zugeschnitten angeboten
        werden.
      </p>
      <p className={styles.infomation_text}>
        Dadurch, dass es sich bei der Twitter Inc. um einen außereuropäischen
        Anbieter handelt, der eine europäische Niederlassung nur in Irland hat,
        ist dieser nach eigener Lesart nicht an deutsche Datenschutzvorschriften
        gebunden. Dies betrifft zum Beispiel Ihre Rechte auf Auskunft, Sperrung
        oder Löschung von Daten oder die Möglichkeit einer Verwendung von
        Nutzungsdaten für Werbezwecke zu widersprechen.
      </p>
      <p className={styles.infomation_text}>
        Möglichkeiten, die Verarbeitung Ihrer Daten zu beschränken, haben Sie
        bei den allgemeinen Einstellungen Ihres Twitter-Kontos sowie unter dem
        Punkt „Datenschutz und Sicherheit“. Darüber hinaus können Sie bei
        Mobilgeräten (Smartphones, Tablet-Computer) in den dortigen
        Einstellmöglichkeiten den Zugriff von Twitter auf Kontakt- und
        Kalenderdaten, Fotos, Standortdaten etc. beschränken. Dies ist jedoch
        abhängig vom genutzten Betriebssystem.
      </p>
      <p className={styles.infomation_text}>
        Weitere Informationen zu diesen Punkten sind auf den folgenden
        Twitter-Supportseiten vorhanden:
      </p>
      <p className={styles.infomation_text}>
        https://support.twitter.com/articles/105576#
      </p>
      <p className={styles.infomation_text}>
        https://help.twitter.com/de/search?q=datenschutz
      </p>
      <p className={styles.infomation_text}>
        Über die Möglichkeit, eigene Daten bei Twitter einsehen zu können,
        können Sie sich hier informieren:
        https://support.twitter.com/articles/20172711#
      </p>
      <p className={styles.infomation_text}>
        Informationen über die von Twitter zu Ihnen gezogenen Rückschlüsse
        finden Sie hier: https://twitter.com/settings/your_twitter_data
      </p>
      <p className={styles.infomation_text}>
        Informationen zu den vorhandenen Personalisierungs- und
        Datenschutzeinstellmöglichkeiten finden Sie hier (mit weiteren
        Verweisen):
      </p>
      <p className={styles.infomation_text}>
        https://twitter.com/personalization
      </p>
      <p className={styles.infomation_text}>
        Weiterhin haben Sie die Möglichkeit, über das
        Twitter-Datenschutzformular oder die Archivanforderungen Informationen
        anzufordern:
      </p>
      <p className={styles.infomation_text}>
        https://support.twitter.com/forms/privacy
      </p>
      <p className={styles.infomation_text}>
        https://support.twitter.com/articles/20170320#
      </p>
      <p className={styles.infomation_text}>
        Änderung unserer Datenschutzbestimmungen
      </p>
      <p className={styles.infomation_text}>
        Unsere Datenschutzerklärung werden wir von Zeit zu Zeit anpassen, damit
        diese stets den aktuellen rechtlichen Anforderungen entspricht.
      </p>
    </div>
  );
};
